import { render, staticRenderFns } from "./related.vue?vue&type=template&id=1c007164&scoped=true"
import script from "./related.vue?vue&type=script&lang=js"
export * from "./related.vue?vue&type=script&lang=js"
import style0 from "./related.vue?vue&type=style&index=0&id=1c007164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c007164",
  null
  
)

export default component.exports